import { UnidadeService } from 'src/app/services/http/unidade.service';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-list-ponto-atendimento',
  templateUrl: './list-ponto-atendimento.component.html',
  styleUrls: ['./list-ponto-atendimento.component.scss']
})
export class ListPontoAtendimentoComponent implements OnInit {

  listaUnidades: any;
  listaPontosAtendimentos: any;
  pontosAtendimento: any;

  form = {
    unidade: new FormControl(''),
    atendimento: new FormControl('')
  }

  order = {
    pontoAtendimento: '',
    documento: '',
    telefone: ''
  }

  first: number = 0;
  pontoAtendimento: any = {};
  dynamicdownloadName: string = "Pontos de Atendimento"

  cols: any = [
    { field: 'nomePontoAtendimento', header: 'Ponto de Atendimento' },
    { field: 'documentoPontoAtendimento', header: 'Documento' },
    { field: 'telefonePontoAtendimento', header: 'Telefone' }
  ];

  constructor(private loginService: LoginService, private unidadeService: UnidadeService, private modalService: ModalMsgService, private router: Router) { }

  ngOnInit() {
    this.unidadeService.getListaUnidadeNomeFantasia().then(u => { 
      this.listaUnidades = u;
      this.listaPontosAtendimentos = u;
      this.loginService.getLogIn().pipe(first()).subscribe(u => {
        this.listaUnidades.splice(0, 0, u.unidade);
      });
    });
    this.form.unidade.valueChanges.pipe(distinctUntilChanged(), debounceTime(300)).subscribe(c => {
      this.selecaoUnidade(c)
    });
  }

  selecaoUnidade(params) {
    if(params && params != '') {
      let id = parseInt(params);
      this.getUnidadeRegistro(id);
    }
  }

  getUnidadeRegistro(id) {
    this.unidadeService.getPontosAtendimento(id).subscribe(p => {
      this.pontosAtendimento = p
    });
  }

  addPontoAtendimento() {
    if(this.form.unidade.value && this.form.atendimento.value) { 
      let params = {
        "unidadeAtendida": parseInt(this.form.unidade.value),
        "pontoAtendimento": parseInt(this.form.atendimento.value),
      }
      if(params.unidadeAtendida != params.pontoAtendimento) {
        this.unidadeService.addPontosAtendimento(params).then( () => {
          this.modalService.openDialog(
            'Ponto de atendimento',
            'Adicionado com sucesso!',
            'success',
            false
          ).finally( () => {
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => this.router.navigate(['unidade', 'ponto-atendimento']));
          });
        }).catch( () => {
          this.modalService.openDialog(
            'Ponto de atendimento',
            'Já existe um ponto de atendimento entre as unidades selecionadas.',
            'danger',
            false
          );
        });
      }else {
        this.modalService.openDialog(
          'Ponto de atendimento',
          'Novo ponto de atendimento não pode ser igual a unidade selecionada.',
          'danger',
          false
        );
      }
    }
  }

  delPontoAtendimento(id) {
    if(id) {
      let params = {id: id}
      this.modalService.justificativa('Remover ponto de atendimento').then(justificativa => {
        if(justificativa) {
          this.unidadeService.delPontosAtendimento(params, justificativa).then( () => {
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => this.router.navigate(['unidade', 'ponto-atendimento']));
          });
        }else{
          this.modalService.openDialog('Erro ao remover ponto de atendimento',
          'Informe uma Justificativa para concluir a operação', 'danger');
        }
      });
    }
  }

  setOrder(){}

}
